import { render, staticRenderFns } from "./CreateStatusBill.vue?vue&type=template&id=44c6373f&"
import script from "./CreateStatusBill.vue?vue&type=script&lang=js&"
export * from "./CreateStatusBill.vue?vue&type=script&lang=js&"
import style0 from "./CreateStatusBill.vue?vue&type=style&index=0&id=44c6373f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports